<template>
  <div class="block-wrap">
    <BlockTitle title-type="member">
      <div>更多会员》</div>
    </BlockTitle>
    <!-- <div class="content-wrap">
      <div class="line-box">
        <div class="card-item" v-for="(item, index) in cardLine1" :key="index">广告{{item}}</div>
      </div>
      <div class="line-box">
        <div class="card-item" v-for="(item, index) in cardLine2" :key="index">广告{{item}}</div>
      </div>
      <div class="line-box">
        <div class="card-item" v-for="(item, index) in cardLine3" :key="index">广告{{item}}</div>
      </div>
    </div> -->
    <div style="margin-top: 57px;margin-bottom: 56px;">
      <img src="../../assets/tempImages/hy.png" width="100%" style="display: block;" alt="">
    </div>
  </div>
</template>

<script>
import BlockTitle from "@/components/BlockTitle";

export default {
  data() {
    return {
      cardList: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19]
    }
  },
  computed: {
    cardLine1() {
      return this.cardList.slice(0, 6);
    },
    cardLine2() {
      return this.cardList.slice(6, 13);
    },
    cardLine3() {
      return this.cardList.slice(13);
    },
  },
  components: {
    BlockTitle,
  }
};
</script>

<style lang="less" scoped>
.block-wrap {
  .content-wrap {
    width: 100%;
    margin-top: 57px;
    margin-bottom: 56px;


    .line-box {
      margin-bottom: 35px;
      text-align: center;
      width: 100%;
      overflow: hidden;

      // .card-item {
      //   &:first-child {
      //     position: relative;

      //     &::after {
      //       content: '';
      //       width: 120px;
      //       height: 100px;
      //       border-radius: 50%;
      //       position: absolute;
      //       left: -30px;
      //       top: -5px;
      //       background: rgba(253, 255, 253, 0.8);
      //       backdrop-filter: blur(10px);
      //     }
      //   }

      //   &:last-child {
      //     position: relative;

      //     &::after {
      //       content: '';
      //       width: 120px;
      //       height: 100px;
      //       border-radius: 50%;
      //       position: absolute;
      //       right: -30px;
      //       top: -5px;
      //       background: rgba(253, 255, 253, 0.8);
      //       backdrop-filter: blur(10px);
      //     }
      //   }
      // }
    }
    
    .card-item {
      width: 160px;
      height: 88px;
      border: 1px solid #E5E5E5;
      margin: 0 7px;
      display: inline-block;
      
      line-height: 88px;

      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>